import React from "react";
import { Popover } from "react-bootstrap";

const ADAPopover = (
  <Popover id="popover-basic">
    <Popover.Title as="h3">ADAAG Compliance Warning</Popover.Title>
    <Popover.Content>
      Changing fonts and/or colors may impact compliance with Americans with
      Disabilities Act Accessibility Guidelines. Please refer to{" "}
      <a href="https://www.ada.gov/"> www.ada.gov</a> for more info.
    </Popover.Content>
  </Popover>
);

export default ADAPopover;
